import React from 'react';
import { Box, Checkbox, Inscription, RequiredIcon } from '@common-fe/common-fe';

interface Props {
  testId?: string;
  title?: string;
  description?: string;
  checkboxTitle?: React.ReactNode;
  isChecked?: boolean;
  setIsChecked: (value: boolean) => void;
  isError?: boolean;
}

const AgreementSection: React.FC<Props> = ({
  testId,
  title,
  description,
  checkboxTitle,
  isChecked,
  setIsChecked,
  isError,
}) => {
  return (
    <Box
      pad={{ vertical: 'spacing24', horizontal: 'spacing32' }}
      background="canvas"
      round="container1Round"
    >
      {title && (
        <Box direction="row">
          <RequiredIcon color="danger" size="10px" style={{ paddingRight: '8px', paddingTop: '12px' }} />
          <Inscription size="xxlarge" lineHeight="40px">
            {title}
          </Inscription>
        </Box>
      )}
      {description && (
        <Inscription margin={{ top: 'spacing16' }} lineHeight="22px" size="large">
          {description}
        </Inscription>
      )}
      <Box margin={{ top: 'spacing16' }}>
        <Checkbox
          testId={testId}
          checked={isChecked}
          onChange={setIsChecked}
          error={isError}
          isLarge
        >
          {checkboxTitle}
        </Checkbox>
      </Box>
    </Box>
  );
};

export default AgreementSection;
